const parseMfr = (envVar) =>
  (envVar || "")
    .split(",")
    .map((m) => m.trim().toLowerCase())
    .filter(Boolean);

const parseSources = (envVar) =>
  (envVar || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

const MANUFACTURER_ACCESS = {
  orgs: parseMfr(process.env.REACT_APP_MFR_ORGS),
  summary: parseMfr(process.env.REACT_APP_MFR_SUMMARY),
  tasks: parseMfr(process.env.REACT_APP_MFR_TASKS),
  files: parseMfr(process.env.REACT_APP_MFR_FILES),
  reports: parseMfr(process.env.REACT_APP_MFR_REPORTS),
  admin: parseMfr(process.env.REACT_APP_MFR_ADMIN),
};

// ✅ Per-manufacturer upload sources
// Falls back to empty array if not configured — component handles gracefully
const MANUFACTURER_SOURCES = new Proxy(
  Object.fromEntries(
    Object.keys(process.env)
      .filter((k) => k.startsWith("REACT_APP_SOURCES_MFR_"))
      .map((k) => [
        k.replace("REACT_APP_SOURCES_MFR_", "").toLowerCase(),
        parseSources(process.env[k]),
      ]),
  ),
  {
    // Unknown manufacturer returns empty array rather than undefined
    get: (target, prop) => target[prop] ?? [],
  },
);

export { MANUFACTURER_SOURCES };
export default MANUFACTURER_ACCESS;
